import { makeStyles } from '@material-ui/core/styles'
import { ALIGN } from '@v4/constants/quiz'

const useStyles = makeStyles(
	() => ({
		root: {
			width: '100%',
			height: '100%',
			display: 'flex',
			margin: ({ align }) => (align === ALIGN.CENTER ? '0 auto' : null),
		},
		content: {
			width: '100%',
			height: '100%',
			position: 'relative',
			margin: 'auto',
		},
		contain: {
			height: 'auto',
			paddingBottom: '56.25%',
			zIndex: 0,
			'& $iframe': {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				zIndex: 0,
			},
		},

		iframe: {
			width: '100%',
			height: '100%',
		},

		overlay: {
			pointerEvents: 'none',
			userSelect: 'none',
			position: 'absolute',
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
			height: '100%',
			backgroundColor: 'black',
			opacity: ({ shading }) => (shading || 0) / 100,
			zIndex: 1,
		},
	}),
	{
		name: 'EmbedVideo',
	},
)

export default useStyles
